
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > services/types <
import { PaymentRequest } from '@/modern/modules/m-accounting-module/services/types/payment-requests.types'

export default defineComponent({
    props: {
        paymentRequest: {
            type: Object as PropType<PaymentRequest>,
            required: true
        },
    },
    emits: ['pay', 'decline'],
    setup(props, { emit }) {
        const onPay = () => {
            emit('pay', props.paymentRequest)
        }

        const onDecline = () => {
            emit('decline', props.paymentRequest)
        }

        return {
            onPay,
            onDecline
        }
    }
})
